import { BlueBadge } from './Badge';
import Icon from './ImageIcon';

const GeneratedCard = (props) => {
  const { place } = props;

  return (
    <div
      key={place.id}
      className="overflow-hidden rounded-xl border bg-gray-50 border-gray-200"
    >
      <div className="flex flex-col items-center gap-x-4 border-b border-gray-900/5 bg-primaryColor p-6">
        <div className="text-lg font-medium text-gray-100">
          {place.location}
        </div>
        <p className="mt-1 truncate text-md text-gray-100">{place.name}</p>
      </div>
      <dl className="-my-3 divide-y divide-gray-300 px-6 bg-white py-4 text-sm leading-6">
        <div className="flex justify-between gap-x-4 py-3">
          <dt className="text-gray-500">Category</dt>
          <dd className="text-gray-700">
            {place.category && <BlueBadge>{place.category}</BlueBadge>}
          </dd>
        </div>
        <div className="flex justify-between gap-x-4 py-3">
          <dt className="inline-block align-bottom text-gray-500 h-10">
            Restriction
          </dt>
          <dd className="flex flex-row items-start space-x-2">
            <div>
              {place.is_halal && (
                <Icon imageUrl="/halal.png" alt="halal logo" />
              )}
            </div>
            <div>
              {place.is_vegetarian && (
                <Icon imageUrl="/vegetarian.jpg" alt="vegetarian logo" />
              )}
            </div>
          </dd>
        </div>
      </dl>
    </div>
  );
};

export default GeneratedCard;
